const initialState = {
  xlsData: [],
  token: null,
  refreshToken: null,
  userName: "",
  plantName: null,
  plantLocation: null,
  water_type: null,
  ro_nf_elements_used: null,
  dataset_name: null,
  sel_train: null,
  sel_rack: null,
  tol_num_modules: null,
  tol_active_area: null,
  is_dupont_element: false,
  num_trains: null,
  sel_modules_per_rack: null,
  sel_active_area: null,
  sel_module_used: null,
  sel_segment: null,
  installation_date: "",
  warranty: false,
  energyPrice: null,
  acidPrice: null,
  alkaliPrice: null,
  waterPrice: null,
  costofDownTime: null,
  additional_chemical_price: null,
  ceb_additional_chemical_price: null,
  cebAcidPrice: null,
  cebAlkaliPrice: null,
  design_bw_duration: null,
  design_duration_btw_bw: null,
  acid_ceb_duration: null,
  acid_ceb_soak_duration: null,
  acid_used_per_ceb: null,
  acid_ceb_ph: null,
  acid_ceb_temp: null,
  alkali_ceb_duration: null,
  alkali_ceb_soak_duration: null,
  alkali_used_per_ceb: null,
  alkali_ceb_ph: null,
  alkali_ceb_temp: null,
  acid_cip_duration: null,
  acid_cip_soak_duration: null,
  acid_used_per_cip: null,
  acid_cip_ph: null,
  acid_cip_temp: null,
  alkali_cip_duration: null,
  alkali_cip_soak_duration: null,
  alkali_used_per_cip: null,
  alkali_cip_ph: null,
  alkali_cip_temp: null,
  file_id: null,
  fileName: null,
  cips: null,
  cleanData: null,
  flow: "m³/h",
  pressure: "bar",
  feed_suspended: "NTU",
  feed_water_factor: "0.7",
  temperature: "C",
  flux: "lmh",
  filtrate_suspended: "NTU",
  feed_water_permeate_factor: "0.5",
  volume: "m³",
  currency: "USD",
  mass: "kg",
  conversion_rate: "1",
  cleaningEffectiness: null,
  fouling: null,
  predictionData: null,
  selectedValues: [],
  forecastWindow: null,
  foulingType: null,
  appLanguage: "en",
  max_feed_pressure: 8,
  max_permeate_quality: 500,
  std_warranty_period: 3,
  startup_pressure_drop: null,
  designed_permeate_flow: null,
  std_membrane_age: 7,
  max_pressure_drop: 3.5,
  min_permeate_flow: null,
  forecast_window: 7,
  analysisData: null,
  taskId: null,
  CATaskId: null,
  app: null,
  window: 7,
  qp_pct_change_threshold: 8,
  tmp_pct_change_threshold: 8,
  short_time_threshold: 180,
  default_approach: "Permeate Flow",
  time1: 3,
  time2: 60,
  minimum_duration_between_cips: 5,
  norm_tmp_threshold: 0.2,
  filtrate_flow_threshold: 0,
  start_tmp_pct_change_threshold: -10,
  minimum_backwash_between_cips: 20,
  minimum_backwash_between_cebs: 10,
  min_shutdown_days: 1,
  norm_tmp_threshold_cip: 0.3,
  optimize_mode: true,
  min_bwd_multiplier: 0.5,
  max_bwd_multiplier: 1.5,
  optimization_target: "Minimize Total Cost",
  cleaningEffectinessThreshold: null,
  is_dupont_element: "Yes",
  add_info: "",
  // cip_soad_duration as it is default
  acid_soak_duration: 2,
  acid_used: 0.1,
  acid_ph: 2,
  acid_temp: 25,
  // cip_soad_duration as it is default
  alkali_soak_duration: 2,
  alkali_used: 0.1,
  alkali_ph: 11,
  alkali_temp: 25,
  digital: "",
  userEmail: "",
  plantRowData: [],
  firstName: "",
  lastName: "",
  companyName: "",
  userCountry: "",
  userRole: "",
  backwashes: [],
  operationalTime: null,
  waterRecovery: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "STORE_XLS_DATA":
      return {
        ...state,
        xlsData: action.payload,
      };
    case "STORE_TOKEN":
      return {
        ...state,
        token: action.payload,
      };
    case "STORE_USERNAME":
      //console.log("action.payload", action.payload);
      return {
        ...state,
        userName: action.payload,
      };
    case "STORE_USERDETAILS":
      return {
        ...state,
        firstName: action.payload.name,
        lastName: action.payload.last_name,
        companyName: action.payload.company,
        userCountry: action.payload.country,
      };
    case "STORE_USERROLE":
      return {
        ...state,
        userRole: action.payload,
      };
    case "STORE_FILE_ID":
      return {
        ...state,
        file_id: action.payload.file_id,
        fileName: action.payload.fileName,
      };
    case "STORE_PLANT_ROW_DATA":
      return {
        ...state,
        plantRowData: action.payload,
      };

    case "STORE_DIGITAL":
      return {
        ...state,
        digital: action.payload,
      };
    case "STORE_PLANT_DETAILS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_CIPS": {
      return {
        ...state,
        cips: [...action.payload],
      };
    }
    case "STORE_BACKWASHES":
      return {
        ...state,
        backwashes: action.payload,
      };
    case "STORE_USEREMAIL":
      return {
        ...state,
        userEmail: action.payload,
      };
    case "STORE_COST_DETAILS": {
      return {
        ...state,
        ...action.payload,
      };
    }

    case "STORE_DEFAULT_DETAILS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_SETTINGS_DEFAULTS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_REPLACEMENT_THRESHOLD": {
      return {
        ...state,
        ...action.payload,
      };
    }

    case "STORE_CLEAN_DATA": {
      return {
        ...state,
        cleanData: action.payload.cleanData,
        cleanDate: action.payload.cleanDate,
      };
    }

    case "STORE_UNITS": {
      return {
        ...state,
        flow: action.payload.flow,
        pressure: action.payload.pressure,
        feed_suspended: action.payload.feed_suspended,
        filtrate_suspended: action.payload.filtrate_suspended,
        temperature: action.payload.temperature,
        flux: action.payload.flux,
        volume: action.payload.volume,
        currency: action.payload.currency,
        mass: action.payload.mass,
        conversion_rate: action.payload.conversion_rate,
      };
    }

    case "STORE_CLEANING_EFFECTIVNESS": {
      return {
        ...state,
        cleaningEffectiness: action.payload,
      };
    }

    case "STORE_FOULING": {
      return {
        ...state,
        fouling: action.payload,
      };
    }
    case "STORE_FOULING_TYPE": {
      return {
        ...state,
        foulingType: action.payload,
      };
    }

    case "STORE_PREDICTION_DATA": {
      return {
        ...state,
        predictionData: action.payload,
      };
    }

    case "STORE_SELECTED_VALUES": {
      return {
        ...state,
        selectedValues: action.payload,
      };
    }

    case "STORE_FORECAST_WINDOW": {
      return {
        ...state,
        forecastWindow: action.payload,
      };
    }
    case "CLEAR_DATA": {
      return {
        ...initialState,
        userName: state.userName,
        token: state.token,
        app: state.app,
        userEmail: state.userEmail,
        requestStatus: state.requestStatus,
        flow: state.flow,
        pressure: state.pressure,
        temperature: state.temperature,
        userCountry: state.userCountry,
        companyName: state.companyName,
        firstName: state.firstName,
        lastName: state.lastName,
      };
    }
    case "STORE_APP_LANGUAGE": {
      return {
        ...state,
        appLanguage: action.payload,
      };
    }
    case "STORE_APP": {
      return {
        ...state,
        app: action.payload,
      };
    }
    case "STORE_ANALYSIS_DATA": {
      return {
        ...state,
        analysisData: action.payload,
      };
    }
    case "STORE_TASK_ID": {
      return {
        ...state,
        taskId: action.payload,
      };
    }
    case "STORE_CA_TASK_ID": {
      return {
        ...state,
        CATaskId: action.payload,
      };
    }
    case "STORE_CLEANING_EFFECTIVNESS_THRESHOLD": {
      return {
        ...state,
        cleaningEffectinessThreshold: action.payload,
      };
    }
    case "STORE_REQUEST_STATUS":
      return {
        ...state,
        requestStatus: action.payload,
      };
    case "STORE_OPERATIONAL_TIME":
      return {
        ...state,
        operationalTime: action.payload,
      };
    case "STORE_WATER_RECOVERY":
      return {
        ...state,
        waterRecovery: action.payload,
      };
    default:
      return state;
  }
};

export default rootReducer;
